import React from "react";
import { ChevronRightIcon } from "@heroicons/react/outline";
import Avatar from "./Avatar";
import ActionRow from "./ActionRow";
import Card from "./Card";

/**
 * Bun list row. Spec: components/data/ListRow. Monogram + name over a muted
 * sub-line, right-aligned meta, faint chevron. For drill-in lists and mobile
 * rows; compose inside a Card (rows separate themselves with line-soft).
 */
export default function ListRow({
  name,
  sub,
  meta,
  chevron = true,
  onClick,
  className,
  children,
}) {
  const content = <>
      <Avatar name={name} size="lg" />
      <div className="flex-1 min-w-0">
        <div className="text-[14px] font-strong text-bun-text truncate">{name}</div>
        {sub && <div className="text-bun-meta font-book text-bun-stone mt-[1px] truncate">{sub}</div>}
      </div>
      {children}
      {meta && <span className="shrink-0 text-bun-meta font-book text-bun-slate">{meta}</span>}
    </>;
  const trailing = chevron && <ChevronRightIcon className="w-[13px] h-[13px] text-bun-faint shrink-0" aria-hidden="true" />;
  return onClick ? (
    <ActionRow as="div" layout="flex" onClick={onClick} className={className} trailing={trailing}>{content}</ActionRow>
  ) : (
    <Card.Row interactive={false} className={className}>{content}{trailing}</Card.Row>
  );
}
